import {Activity, ActivityType} from '../activity';
import {ActorType} from '../enumerations/actor-type';
import {DeleteResourcesTargetType} from '../enumerations/delete-resources-target-type';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class DeleteResourcesActivity extends Activity {
  public TargetType: DeleteResourcesTargetType;
  public TargetExpression: string;
  public Advanced: boolean;
  public ActivityExecutionCondition: string;
  public Iteration: string;
  public ActorType: ActorType;
  public ActorString: string;
  public ApplyAuthorizationPolicy: boolean;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.DeleteResources);
    this._properties['TargetType'] = ActivityPropertyDataType.DELETE_RESOURCES_TARGET_TYPE;
    this._properties['TargetExpression'] = ActivityPropertyDataType.STRING;
    this._properties['Advanced'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['Iteration'] = ActivityPropertyDataType.STRING;
    this._properties['ActorType'] = ActivityPropertyDataType.ACTOR_TYPE;
    this._properties['ActorString'] = ActivityPropertyDataType.STRING;
    this._properties['ApplyAuthorizationPolicy'] = ActivityPropertyDataType.BOOLEAN;
    this._advancedProperties = [
      'ActivityExecutionCondition',
      'Iteration',
      'ActorType',
      'ActorString',
      'ApplyAuthorizationPolicy',
    ];
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();

    if (this.TargetType === DeleteResourcesTargetType.WorkflowTarget) {
      this.TargetExpression = null;
    }

    if (this.ActorType !== ActorType.Resolve && this.ActorType !== ActorType.Account) {
      this.ActorString = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('delete-resources', this.dialogConfig);
  }
}
